import { render, staticRenderFns } from "./TrocarSenha.vue?vue&type=template&id=7d3e7765&scoped=true"
import script from "./TrocarSenha.vue?vue&type=script&lang=js"
export * from "./TrocarSenha.vue?vue&type=script&lang=js"
import style0 from "./TrocarSenha.vue?vue&type=style&index=0&id=7d3e7765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3e7765",
  null
  
)

export default component.exports